import { render } from "./complete.vue?vue&type=template&id=08dc686f&scoped=true&ts=true"
import script from "./complete.vue?vue&type=script&lang=ts"
export * from "./complete.vue?vue&type=script&lang=ts"

import "./complete.vue?vue&type=style&index=0&id=08dc686f&lang=scss&scoped=true"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08dc686f"]])

export default __exports__